import { ModalActionType, OrderTypeModal } from "#/organisms";
import { useCallback, useEffect, useRef, useState } from "react";

import { NewOrderTypeParam } from "@/api/orderTypes/interface";
import { OrderType } from "@/types";
import { OrderTypes } from "#/pages";
import { useApi } from "@/api";
import { useModal } from "@/hooks";

const OrderTypesView = () => {
  const { orderType } = useApi();
  // const [orderTypes, setrderTypes] = useState<OrderType | null>(null);
  const [editOrder, setEditOrder] = useState<OrderType | null>(null);
  const [modalType, setModalType] = useState<ModalActionType | null>(null);
  const [loadingOrderTypes, setLoadingOrderTypes] = useState(false);
  const { showModal, onCloseModal, onOpenModal } = useModal();

  const orderRef = useRef<OrderType[]>([]);

  const getOrderTypesList = async () => {
    setLoadingOrderTypes(true);
    await orderType.getEditList();
    setLoadingOrderTypes(false);
  }

  useEffect(() => {
    if (orderType.orderTypes.length === 0) {
       getOrderTypesList();
    }
  }, [orderType, orderType.orderTypes]);

  useEffect(() => {
    orderRef.current = orderType.orderTypes;
  }, [orderType.orderTypes]);

  const handleNewOrderModal = () => {
    setModalType('create');
    setEditOrder(null);
    onOpenModal();
  };

  const handleEditOrderModal =  useCallback((id: string) => {
    const orderToEdit = orderRef.current.find((item) => item.id === id);

    if (orderToEdit) {
      setEditOrder(orderToEdit);
      setModalType('edit');
      onOpenModal();
    }
  }, [orderType, orderType.orderTypes]);


  const handleCloseModal = () => {
    setModalType(null)
    onCloseModal();
  };

  const handleDelete = async (id: string) => {
    await orderType.deleteOrderType(id);
    await orderType.getEditList();
    onCloseModal();
  };

  const handleEdit = useCallback(async (data: OrderType, file?: Blob | null) => {
    await orderType.setOrderType(data);

    if (file) {
      await orderType.uploadImage(file, data.id);
    }

    await orderType.getEditList();
    onCloseModal();
  }, [orderType, orderType.orderTypes]);

  const handleSave = useCallback(async (data: NewOrderTypeParam, file: Blob | null) => {
    const id = await orderType.createOrderType(data);

    if (file) {
      await orderType.uploadImage(file, id);
    }

    await getOrderTypesList();
    onCloseModal();

    return id;
  }, [orderType, orderType.orderTypes]);

  return (
    <>
      {orderType.orderTypes.length > 0 && <><OrderTypes
        loading={loadingOrderTypes}
        ordersType={orderType.orderTypes}
        onEdit={handleEditOrderModal}
        onNew={handleNewOrderModal}
      />
      {showModal && modalType && (
        <OrderTypeModal
          actionType={modalType}
          onClose={handleCloseModal}
          onDelete={handleDelete}
          onEdit={handleEdit}
          onSave={handleSave}
          order={editOrder}
        />
      )}</> }
    </>
  );
}

export default OrderTypesView;